module.exports = __webpack_public_path__ + "static/media/nosql.ed89351d.md";